module.exports = __webpack_public_path__ + "img/home-line4-img1.acde8ffe.png";